import { Injectable, Injector } from '@angular/core';



import { $frontendTypes } from './SalesOrders.frontend.types'

@Injectable({ providedIn: 'root' })
export class SalesOrders_FrontendFlowService {

  constructor(
    private injector: Injector
  ) {
  }

  public SalesOrders: SalesOrders_FrontendFlowService = this;

  // injecting lazily in order to avoid circular dependencies
}
